// extracted by mini-css-extract-plugin
export default {"container":"Favorites_container__pF5Ne"};